<template>
    <div class="jd-page--orderDetail">
        <div v-if="getOrderDetail">
            <div class="jd-order-detailStatus--text" v-if="getOrderDetail.status === CONST.ORDER_STATUS_CANCEL">
                <order-status-text :status="getOrderDetail.status" :payst="getOrderDetail.payst" :dotimest="getOrderDetail.dotimest" />
            </div>
            <appraiser-result v-if="showResult" :info="resultInfo" :appraiser="getOrderDetail.appraiser" />
            <goods-info :des="getOrderDetail.des || ''" :files="getOrderDetail.files" :pictures="getOrderDetail.pictures"  :num="true">
                <span slot="right" class="cl-primary" v-if="showLeftTime && dotimeps>0">鉴定倒计时 {{dotimeps|formatTime}}</span>
            </goods-info>
            <evaluate-info v-if="getOrderDetail.status === CONST.ORDER_STATUS_EVALUATE" :star="getOrderDetail.star || 0" server="非常满意" speed="非常满意" />

            <order-info :info="orderInfo" />

            <div class="jd-fixed-btns">
                <k-row type="flex" gutter="10">
                    <k-col v-if="getOrderDetail.status === CONST.ORDER_STATUS_WAIT" span="24"><k-button type="default" block @click="showPopup(1)">取消订单</k-button></k-col>
                    <k-col v-if="getOrderDetail.status === CONST.ORDER_STATUS_WAIT" span="24"><k-button type="default" block @click="showPopup(2)">资料模糊</k-button></k-col>
                    <k-col v-if="showJdBtn" span="24"><k-button type="primary" block :to="`/appraiser/appraisal?orderId=${id}`">开始鉴定</k-button></k-col>
                </k-row>
            </div>
        </div>
        <template v-if="getOrderDetail">
            <k-popup v-model="popupShow" position="bottom" class="k-popup--round">
                <k-icon name="close-o" size="26" color="gainsboro" class="" @click="popupShow=false" />
                <cancel-order v-if="popupActive === 1" @success="cancelOrder" />
                <order-redo v-if="popupActive === 2" @success="redoOrder" :files="getOrderDetail.files" :pictures="getOrderDetail.pictures" />
            </k-popup>
        </template>

    </div>
</template>

<script>
    import {mapActions, mapGetters, mapMutations} from "vuex"
    import AppraiserResult from "../components/appraiser-result"
    import EvaluateForm from "../components/evaluate-form"
    import EvaluateInfo from "../components/evaluate-info"
    import GoodsInfo from "../components/goods-info"
    import OrderStatusText from "../components/order-status-text"
    import OrderInfo from "../components/order-info"
    import CancelOrder from "./mod/cancel-order"
    import OrderRedo from "./mod/order-redo"
    export default {
        name: "order-detail",
        data(){
            return {
                id : this.$route.query.orderId || 0,
                popupShow : false,
                popupActive : 2
            }
        },
        computed : {
            ...mapGetters("jianding", ["getOrderDetail","CONST"]),
            ...mapGetters("timer", ["leftSecs"]),
            showLeftTime(){
                let od = this.getOrderDetail;
                let {ORDER_STATUS_WAIT} = this.CONST;
                if(!od.dotimest && od.status === ORDER_STATUS_WAIT) {
                    return true
                }
                return false
            },
            showJdBtn(){
                let od = this.getOrderDetail;
                let {ORDER_STATUS_WAIT, ORDER_STATUS_PAUSE} = this.CONST;
                if (od.status === ORDER_STATUS_WAIT) {
                    return true
                }
                return false
            },
            showResult(){
                let od = this.getOrderDetail;
                let {ORDER_STATUS_FINISHED, ORDER_STATUS_EVALUATE} = this.CONST;
                if (od.status === ORDER_STATUS_FINISHED || od.status === ORDER_STATUS_EVALUATE) {
                    return true
                }
                return false
            },
            resultInfo(){
                let {id, aid, type, definition, periods, trend, reply, isReal} = this.getOrderDetail;
                return {id, aid, type, definition, periods, trend, reply, isReal}
            },
            orderInfo(){
                let {id, orderno, status, money, createtime, paytime, payps, payst} = this.getOrderDetail;
                return {id, orderno, status, money, createtime, paytime, payps, payst}
            },
            goodsInfo(){
                let {des, pictures, files } = this.getOrderDetail;
                return {des, pictures, files }
            },
            appraiserInfo(){
                let {appraiser } = this.getOrderDetail;
                let {aid, name, des, logo, tabs} = appraiser;
                return {
                    aid,
                    name,
                    img     : logo,
                    tags    : tabs,
                    des     : des
                }
            },
            dotimeps(){
                let {dotimeps} = this.getOrderDetail;
                return this.leftSecs(dotimeps*1000)
            },
        },
        components : {
            AppraiserResult,
            EvaluateForm,
            EvaluateInfo,
            GoodsInfo,
            OrderStatusText,
            OrderInfo,
            CancelOrder,
            OrderRedo
        },
        methods : {
            ...mapActions("jianding", ["loadOrderDetail"]),
            ...mapMutations("jianding", ["delOrderDetail"]),
            success(data){
                console.log(data)
            },
            showPopup(type) {
                this.popupActive = type;
                this.popupShow = true
            },
            cancelOrder(){
                this.popupShow = false
            },
            redoOrder(){
                this.popupShow = false
            }
        },
        created() {
            this.loadOrderDetail({id:this.id})
        },
        beforeDestroy() {
            this.delOrderDetail()
        }
    }
</script>

<style scoped>

</style>